module.exports = __webpack_public_path__ + "static/media/bi_mascot_vic_and_ddory_m.95ff58a3.png";